import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  PriceBookContainerModel,
  PriceBookService
} from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-util-pricebook',
  templateUrl: './pricebook.component.html',
  styleUrls: ['./pricebook.component.css']
})
export class SelectPricebookComponent implements OnInit, OnDestroy {
  @Input() priceBook = new FormControl();
  @Output() priceBookSelected = new EventEmitter<PriceBookContainerModel>();

  selectedEntity: PriceBookContainerModel;
  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<PriceBookContainerModel[]> = new ReplaySubject<PriceBookContainerModel[]>(1);
  entityList: PriceBookContainerModel[];

  constructor( private priceBookService: PriceBookService, ) {}

  ngOnInit() {
    this.subs.sink = this.priceBookService.get(this.apiVisa).subscribe(
      {next: resolve => {
        let empty = new PriceBookContainerModel();
        this.entityList = [empty,...resolve.data];
        this.filteredOptions$.next(this.entityList);
      }});
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterCurrency(resolve)});
  }

  filterCurrency(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.entityList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.entityList.filter(c => c.bl_fi_mst_price_book_hdr.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  onSelect(entityGuid: string) {
    console.log('pricing', entityGuid);
    if (entityGuid) {
      this.priceBook.patchValue(entityGuid);
      this.selectedEntity = this.entityList.find(agent => agent.bl_fi_mst_price_book_hdr.guid === entityGuid);
      this.priceBookSelected.emit(this.selectedEntity);
     
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
